<template>
  <section class="text-center speak-with-us">
    <h4 class="mb-2 mt-6">
      Need help planning your dive holiday in {{ where }}?
    </h4>
    <p class="mb-6">
      Get in touch with our expert travel team and plan your next dive trip
    </p>

    <div>
      <img
        class="mb-8 mx-auto"
        :src="getCloudinaryImage()"
        alt="ZuBlu Expert Travel Team"
        width="280px"
      />
    </div>

    <div class="inline-flex gap-4 sm:flex-col sm:w-full">
      <a href="/enquiry" class="inline-block sm:w-full">
        <button
          type="button"
          class="btn btn-primary flex items-center sm:w-full sm:justify-center"
        >
          <svg width="24" height="24" class="fill-white mr-2">
            <use xlink:href="/img/sprite.svg#ic_send"></use>
          </svg>
          Send enquiry
        </button>
      </a>

      <trengo-link>
        <template v-slot="{ openChat }">
          <button
            type="button"
            class="btn btn-primary btn-outlined flex items-center sm:justify-center"
            @click="openChat()"
          >
            <svg width="24" height="24" class="fill-current mr-2">
              <use xlink:href="/img/sprite.svg#ic_chat"></use>
            </svg>
            Chat with us
          </button>
        </template>
      </trengo-link>
    </div>

    <div class="flex justify-center items-center sm:flex-col mt-6">
      <div class="flex items-center mx-2 sm:mx-0 sm:my-2">
        <svg
          style="fill: currentColor"
          width="24"
          height="24"
          class="fill-black-light-5 text-black-light-5 mr-2"
        >
          <use xlink:href="/img/sprite.svg#ic_beach"></use>
        </svg>
        <span class="text-black-light-5">Expert travel advice</span>
      </div>
      <div class="flex items-center mx-2 sm:mx-0 sm:my-2">
        <svg
          style="fill: currentColor"
          width="24"
          height="24"
          class="fill-black-light-5 text-black-light-5 mr-2"
        >
          <use xlink:href="/img/sprite.svg#ic_dollar"></use>
        </svg>
        <span class="text-black-light-5">Best price guarantee</span>
      </div>
      <div class="flex items-center mx-2 sm:mx-0 sm:my-2">
        <svg
          style="fill: currentColor"
          width="24"
          height="24"
          class="fill-black-light-5 text-black-light-5 mr-2"
        >
          <use xlink:href="/img/sprite.svg#ic_clock"></use>
        </svg>
        <span class="text-black-light-5">24/7 customer support</span>
      </div>
    </div>
  </section>
</template>

<script>
import { getCloudinaryUrl } from "../../helpers";
import TrengoLink from "../core/TrengoLink";

export default {
  components: {
    TrengoLink,
  },
  data() {
    return {
      where: window.zubluDestination.name,
    };
  },
  methods: {
    getCloudinaryImage() {
      const origin = window.location.origin;
      return getCloudinaryUrl(`${origin}/img/team_image_2024.png`);
    },
  },
};
</script>
